import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApplicationInsightsService } from '../AppInsight/application-insight.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  constructor(private appInsightsService: ApplicationInsightsService) {
    super();
  }

  handleError(err: Error) {
    if (!environment.production) {
      console.error(err);
    }

    this.appInsightsService.logException(err);
  }
}
